// @flow

import { useFormStatusContext } from './use-form-status-context';

export function useFormHasBeenSent(): boolean {
  const [formStatus] = useFormStatusContext();
  return formStatus === 'sent';
}
